import {Route} from "../../../registry/routes.js"
import properties from "../../../components/files/Properties.vue";

const r = new Route("properties", "properties/:id", {"properties":properties}, {componentType:"bin_modal_component",title:"Properties"}, [], true, (to, from, next)=>{document.title=`${document.title}`;next();})

export default r